<template>
  <li>
    <item-card :content="false">
      <template v-slot:title>
        <template v-if="editableItem.id !== item.id">
          <div class="flex flex-wrap">
            <item-text title="Nosaukums" :text="item.name" />
            <item-text title="Saīsinājums" :text="item.short_name" />
          </div>
        </template>
      </template>
      <template v-slot:buttons>

        <template v-if="editableItem.id !== item.id">

          <Button icon="pencil" @click="editItem(item)" />

          <Button icon="delete" @click="deleteUnit(item.id)" />

        </template>
      </template>

      <template v-slot:content>
      </template>
      <template v-slot:additional>

        <template v-if="editableItem.id === item.id">
          <EditMeasureUnit :item="item"/>
        </template>

      </template>

    </item-card>
  </li>
</template>

<script>
import {mapGetters} from "vuex"
import ItemCard from "@/components/Components/ItemCard"
import ItemText from "@/components/Components/ItemText"
import EditMeasureUnit from "@/components/Settings/CompanySettings/MeasureUnits/EditMeasureUnit"

export default {
  name: "SingleMeasureUnit",
  components: {
    ItemCard,
    ItemText,
    EditMeasureUnit,
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      editableItem: 'editableItem'
    })
  },
  methods: {
    editItem(item){
      this.$store.dispatch('setEditableItem', item)
    },
    deleteUnit(itemId){
      if(confirm('Vai esi drošs?')){
        this.$Progress.start()
        this.$store.dispatch('deleteUnit', itemId)
      }
    }
  }
}
</script>
